// AIDEV-NOTE: Navegacao hierarquica do catalogo (Secao > Grupo > Subgrupo). Componente de
// apresentacao: recebe os nos ja resolvidos (ver services/catalogo-arvore.ts) e devolve o novo
// caminho nos callbacks. Quem decide entre mostrar nos ou produtos e o Step2Catalogo.

import { memo } from 'react';
import { Box, List, ListItemButton, ListItemText, Chip, Breadcrumbs, Link } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import type { NoArvore } from '../services/catalogo-arvore';

interface CatalogoArvoreProps {
  /** Nos a exibir no nivel atual — vazio em folha (o pai lista os produtos) */
  nos: NoArvore[];
  /** Nos percorridos ate aqui, para o breadcrumb */
  trilha: NoArvore[];
  /** Caminho atual (valores); o componente monta o novo caminho e devolve */
  caminho: string[];
  onNavegar: (caminho: string[]) => void;
}

export const CatalogoArvore = memo(function CatalogoArvore({
  nos,
  trilha,
  caminho,
  onNavegar
}: CatalogoArvoreProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      {/* AIDEV-NOTE: "Todos" sempre presente — e a unica saida quando o vendedor desce varios
          niveis no celular, onde nao ha botao de voltar do navegador dentro do wizard. */}
      <Breadcrumbs sx={{ mb: 1, px: 0.5 }} aria-label="caminho do catálogo">
        <Link
          component="button"
          type="button"
          underline="hover"
          color={trilha.length === 0 ? 'text.primary' : 'inherit'}
          onClick={() => onNavegar([])}
        >
          Todos
        </Link>
        {trilha.map((no, idx) => (
          <Link
            key={`${no.nivel}-${no.valor}`}
            component="button"
            type="button"
            underline="hover"
            color={idx === trilha.length - 1 ? 'text.primary' : 'inherit'}
            onClick={() => onNavegar(caminho.slice(0, idx + 1))}
          >
            {no.label}
          </Link>
        ))}
      </Breadcrumbs>

      {nos.length > 0 && (
        <Box sx={{ flex: 1, overflow: 'auto', minHeight: 0, overscrollBehavior: 'contain' }}>
          <List disablePadding>
            {nos.map((no) => (
              <ListItemButton
                key={`${no.nivel}-${no.valor}`}
                onClick={() => onNavegar([...caminho, no.valor])}
                sx={{ borderBottom: '1px solid', borderColor: 'divider', gap: 1 }}
              >
                <ListItemText
                  primary={no.label}
                  primaryTypographyProps={{ fontWeight: 500, noWrap: true }}
                />
                <Chip label={no.total} size="small" variant="outlined" />
                <ChevronRightIcon fontSize="small" color="action" />
              </ListItemButton>
            ))}
          </List>
        </Box>
      )}
    </Box>
  );
});
